module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "FRONT.VI"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0005#rFRONT.VI"
    }
  }, [_vm._v("VI. Analysis of Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('p', {
    staticClass: "nl"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I"
    }
  }, [_c('b', [_vm._v("I. PREPARATION FOR DEPARTURE (1:1–10:10)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A"
    }
  }, [_vm._v("A. Matters Concerning the People and the Camp (1:1–6:27)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1"
    }
  }, [_vm._v("1. The Censuses and the Arrangements of the March (1:1–4:49)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1.A"
    }
  }, [_vm._v("a. First Lay Census (1:1–54)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1.A.1"
    }
  }, [_vm._v("(1) The Leaders (1:1–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1.A.2"
    }
  }, [_vm._v("(2) The Census Itself (1:17–47)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl5"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1.A.2.A"
    }
  }, [_vm._v("(a) Introduction (1:17–19)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl5"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1.A.2.B"
    }
  }, [_vm._v("(b) The census lists (1:20–47)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1.A.3"
    }
  }, [_vm._v("(3) Levites Are Excepted (1:48–54)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1.B"
    }
  }, [_vm._v("b. Placement of the Camp and Marching Order (2:1–34)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1.C"
    }
  }, [_vm._v("c. Levitical Censuses (3:1–4:49)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1.C.1"
    }
  }, [_vm._v("(1) General Census (3:1–39)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl5"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1.C.1.A"
    }
  }, [_vm._v("(a) Introduction: Family of Aaron (3:1–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl5"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1.C.1.B"
    }
  }, [_vm._v("(b) The census itself (3:14–39)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1.C.2"
    }
  }, [_vm._v("(2) Levites for Firstborn (3:40–51)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1.C.3"
    }
  }, [_vm._v("(3) Census of Working Levites (4:1–49)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.A.2"
    }
  }, [_vm._v("2. Various Legal Enactments (5:1–6:21)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.A.2.A"
    }
  }, [_vm._v("a. Camp Must Be Kept Free from Those with Serious Skin Disease (5:1–4)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.A.2.B"
    }
  }, [_vm._v("b. Restitution When There Is No Kinsman (5:5–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.A.2.C"
    }
  }, [_vm._v("c. The Jealous Husband (5:11–31)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.A.2.D"
    }
  }, [_vm._v("d. Law of the Nazirite (6:1–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.A.2.E"
    }
  }, [_vm._v("e. Conclusion: Aaronic Benediction (6:22–27)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.B"
    }
  }, [_vm._v("B. Various Matters concerning the Tabernacle (7:1–10:10)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.B.1"
    }
  }, [_vm._v("1. Offerings by Tribal Leaders (7:1–89)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.B.2"
    }
  }, [_vm._v("2. Lamps in the Tabernacle (8:1–4)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.B.3"
    }
  }, [_vm._v("3. Consecration of Levites (8:5–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.B.4"
    }
  }, [_vm._v("4. The Levites’ Work (8:23–26)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.B.5"
    }
  }, [_vm._v("5. Supplement to the Passover Law (9:1–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.B.6"
    }
  }, [_vm._v("6. Preparations to Depart (9:15–10:10)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.B.6.A"
    }
  }, [_vm._v("a. Fiery Cloud (9:15–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.B.6.B"
    }
  }, [_vm._v("b. Silver Trumpets (10:1–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0019#NUM.II"
    }
  }, [_c('b', [_vm._v("II. THE JOURNEY FROM MT. SINAI TO KADESH-BARNEA (10:11–12:16)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0019#NUM.II.A"
    }
  }, [_vm._v("A. Departure from Mt. Sinai (10:11–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.16"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0019#NUM.II.B"
    }
  }, [_vm._v("B. Crises of Authority on the Way (11:1–12:16)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0019#NUM.II.B.1"
    }
  }, [_vm._v("1. At Taberah (11:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0019#NUM.II.B.2"
    }
  }, [_vm._v("2. At Kibroth-hattaavah (11:4–35)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0019#NUM.II.B.3"
    }
  }, [_vm._v("3. At Hazeroth (12:1–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III"
    }
  }, [_c('b', [_vm._v("III. IN AND AROUND KADESH-BARNEA (13:1–19:22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.A"
    }
  }, [_vm._v("A. The Spies (13:1–14:45)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.A.1"
    }
  }, [_vm._v("1. Spies Are Selected (13:1–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.A.2"
    }
  }, [_vm._v("2. Spies Go and Return (13:17–33)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.A.3"
    }
  }, [_vm._v("3. Responses to the Spies’ Reports (14:1–45)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.A.3.A"
    }
  }, [_vm._v("a. Responses by People and Leaders (14:1–10a)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.A.3.B"
    }
  }, [_vm._v("b. Yahweh Responds (14:10b–38)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.A.3.C"
    }
  }, [_vm._v("c. The People Attempt to Enter Canaan (14:39–45)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.B"
    }
  }, [_vm._v("B. Cultic Legislation (15:1–41)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.B.1"
    }
  }, [_vm._v("1. Supplementary Laws of the Offerings (15:1–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.B.2"
    }
  }, [_vm._v("2. First of the Dough (15:17–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.B.3"
    }
  }, [_vm._v("3. Purification Offering (15:22–31)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.B.4"
    }
  }, [_vm._v("4. Case Law on Capital Punishment for Sabbath Violation (15:32–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.B.5"
    }
  }, [_vm._v("5. Tassels on Garments for Remembrance (15:37–41)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.C"
    }
  }, [_vm._v("C. Legitimation of Aaron’s Priesthood (16:1–17:28 [Eng. 13])")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.C.1"
    }
  }, [_vm._v("1. Rebellions of Korah, Dathan, and Abiram (16:1–35)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.C.2"
    }
  }, [_vm._v("2. Aftermath of Rebellions (17:1–15 [Eng. 16:36–50])")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.C.3"
    }
  }, [_vm._v("3. Aaron’s Budding Rod (17:16–28 [Eng. 17:1–13])")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.D"
    }
  }, [_vm._v("D. Further Cultic Legislation (18:1–19:22)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.D.1"
    }
  }, [_vm._v("1. Redefined Role for Priests and Levites (18:1–32)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.D.1.A"
    }
  }, [_vm._v("a. Responsibilities of Priests and Levites (18:1–7)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.D.1.B"
    }
  }, [_vm._v("b. Support of Priests (18:8–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.D.1.C"
    }
  }, [_vm._v("c. Support of Levites (18:21–24)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.D.1.D"
    }
  }, [_vm._v("d. Tithe of the Tithe (18:25–32)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.D.2"
    }
  }, [_vm._v("2. The Red Cow (19:1–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.D.2.A"
    }
  }, [_vm._v("a. Making the Waters of Impurity (19:1–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.D.2.B"
    }
  }, [_vm._v("b. Using the Waters of Impurity (19:11–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0022#NUM.IV"
    }
  }, [_c('b', [_vm._v("IV. THE JOURNEY FROM KADESH-BARNEA TO THE PLAINS OF MOAB (20:1–22:1)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0022#NUM.IV.A"
    }
  }, [_vm._v("A. Death of Miriam and Disaster at Meribah (20:1–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0022#NUM.IV.B"
    }
  }, [_vm._v("B. Request to Pass through Edom (20:14–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0022#NUM.IV.C"
    }
  }, [_vm._v("C. Death of Aaron (20:22–29)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0022#NUM.IV.D"
    }
  }, [_vm._v("D. Second Battle of Hormah (21:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0022#NUM.IV.E"
    }
  }, [_vm._v("E. Fiery Serpents (21:4–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0022#NUM.IV.F"
    }
  }, [_vm._v("F. Travel Itinerary (21:10–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.17"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0022#NUM.IV.G"
    }
  }, [_vm._v("G. Wars against Sihon and Og (21:21–22:1)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V"
    }
  }, [_c('b', [_vm._v("V. ON THE PLAINS OF MOAB (22:2–36:13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A"
    }
  }, [_vm._v("A. Story of Balaam (22:2–24:25)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.1"
    }
  }, [_vm._v("1. Encounter between Balak and Balaam (22:2–40)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.1.A"
    }
  }, [_vm._v("a. Messengers Find Balaam (22:2–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.1.B"
    }
  }, [_vm._v("b. Balaam and the Donkey (22:22–35)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.1.C"
    }
  }, [_vm._v("c. Balak Meets with Balaam (22:36–40)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.2"
    }
  }, [_vm._v("2. First and Second Oracles (22:41–23:30)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.2.A"
    }
  }, [_vm._v("a. Introductory Preparations (22:41–23:6)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.2.B"
    }
  }, [_vm._v("b. First Oracle (23:7–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.2.C"
    }
  }, [_vm._v("c. Second Oracle (23:13–26)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.3"
    }
  }, [_vm._v("3. Third, Fourth, and Final Oracles (23:27–24:25)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.3.A"
    }
  }, [_vm._v("a. Third Oracle (23:27–24:13)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.3.B"
    }
  }, [_vm._v("b. Fourth Oracle (24:14–19)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.3.C"
    }
  }, [_vm._v("c. Final Oracles (24:20–25)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.B"
    }
  }, [_vm._v("B. Incident of Baal-Peor (25:1–18)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0024#NUM.V.C"
    }
  }, [_vm._v("C. Second Census (25:19–26:65 [Eng. 26:1–65])")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0024#NUM.V.D"
    }
  }, [_vm._v("D. Daughters of Zelophehad (27:1–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0024#NUM.V.E"
    }
  }, [_vm._v("E. Joshua Named as Moses’ Successor (27:12–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0024#NUM.V.F"
    }
  }, [_vm._v("F. Further Legislation (28:1–30:17 [Eng. 16])")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0024#NUM.V.F.1"
    }
  }, [_vm._v("1. Cultic Calendar (28:1–30:1 [Eng. 28:1–29:40])")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0024#NUM.V.F.2"
    }
  }, [_vm._v("2. Women’s Vows (30:2–17 [Eng. 1–16])")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0024#NUM.V.G"
    }
  }, [_vm._v("G. War with Midian (31:1–54)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.H"
    }
  }, [_vm._v("H. Transjordanian Inheritance (32:1–42)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.I"
    }
  }, [_vm._v("I. Travel Itinerary (33:1–49)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.J"
    }
  }, [_vm._v("J. Regulations for Living in Canaan (33:50–36:13)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.J.1"
    }
  }, [_vm._v("1. Introduction: Canaanites Must Be Expelled (33:50–56)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.J.2"
    }
  }, [_vm._v("2. Borders of the Land (34:1–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.J.3"
    }
  }, [_vm._v("3. Leaders to Draw Israel’s Borders (34:16–29)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.J.4"
    }
  }, [_vm._v("4. Cities of the Levites (35:1–8)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.J.5"
    }
  }, [_vm._v("5. Cities of Refuge (35:9–34)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.J.6"
    }
  }, [_vm._v("6. Additional Legislation for Daughters of Zelophehad (36:1–13)")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2371d4c9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eer-nicot04nu-0014.vue
// module id = 93
// module chunks = 0